import { createBenefitsAPI} from './api';
import URLS from '@/constants/api';

export const createBenefits = async (benefitsData: any, feedImage:any, pageImage:any) => {
  const response = await createBenefitsAPI(URLS.CREATE_BENEFITS, benefitsData, feedImage, pageImage);
  return response;
};
